import { render } from "./VerifyOtpModal.vue?vue&type=template&id=2ca92504"
import script from "./VerifyOtpModal.vue?vue&type=script&lang=js"
export * from "./VerifyOtpModal.vue?vue&type=script&lang=js"
script.render = render

export default script